import React from "react";
import classes from "./FilterBar.module.css";
import { Autocomplete, TextField } from "@mui/material";

const FilterBar = ({
  onFilterChange,
  filterValue,
  customClass,
  options: customOptions,
}) => {
  const defaultOptions = [
    { value: "", label: "All" },
    { value: "waitingForApproval", label: "Waiting for Approval" },
    { value: "Approved", label: "Approved" },
    { value: "Cancelled", label: "Cancelled" },
  ];
  const options =
    Array.isArray(customOptions) && customOptions.length > 0
      ? customOptions
      : defaultOptions;

  return (
    <div className={`${classes.filter_wrapper} ${customClass} flex`}>
      <Autocomplete
        disablePortal={false}
        sx={{
          minHeight: "4.2rem",
          width: "100%",
          height: "auto",
          fontSize: "4rem",
          transition: "0",
          ".Mui-expanded": {
            transition: "none",
          },
          ".MuiOutlinedInput-notchedOutline": {
            border: "0",
          },
          ".MuiAutocomplete-input": {
            fontSize: "1.4rem",
            fontFamily: "GilroyMedium",
            height: "2.6rem",
          },
          ".MuiFormLabel-root": {
            display: "none",
          },
          ".MuiChip-root": {
            height: "30px",
            padding: "5px",
          },
        }}
        size="medium"
        options={options}
        getOptionLabel={(option) => option.label}
        value={options.find((option) => option.value === filterValue) || null}
        onChange={(_event, newValue) => onFilterChange(newValue?.value || "")}
        slotProps={{
          popper: {
            sx: { zIndex: 3000 },
          },
        }}
        renderInput={(params) => (
          <TextField {...params} label="Filter" variant="outlined" />
        )}
      />
    </div>
  );
};

export default FilterBar;
